import React from 'react';

import { Drawer, type IDrawerProps } from 'wui/Drawer';
import { DialogContainer } from 'wui/DialogContainer';
import { DialogTitle } from 'wui/DialogTitle';
import { DialogActions } from 'wui/DialogActions';
import { DialogContent } from 'wui/DialogContent';
import { Button } from 'wui/Button';
import { Divider } from 'wui/Divider';

import { EventForm, IEventForm } from './EventForm';
import { EventPage } from './EventPage';
import { EventActions } from './types';

interface EventDrawerProps extends IDrawerProps {
  title: string;
  subtitle: string;
  actions: EventActions;

  isLoading?: boolean;
  onSubmit(values: IEventForm): void;
  onBusyStateChange(isBusy: boolean): void;
  initialValues: IEventForm;
}

export function EventDrawer(props: EventDrawerProps) {
  const {
    isLoading,
    initialValues,
    onSubmit,
    onBusyStateChange,
    actions,
    title,
    subtitle,
    ...drawerProps
  } = props;

  return (
    <Drawer {...drawerProps} hideCloseButton={false} anchor="right">
      <EventPage
        initialValues={initialValues}
        onSubmit={onSubmit}
        onBusyStateChange={onBusyStateChange}
      >
        <DialogContainer>
          <DialogTitle
            id="gs-dialog-title"
            title={title}
            subtitle={subtitle}
            titleProps={{ variant: 'h2-20', align: 'left' }}
            subtitleProps={{ align: 'left' }}
          />
          <Divider bw />
          <DialogContent divider>
            <EventForm />
          </DialogContent>
          <DialogActions>
            <Button
              outlined
              fullWidth
              type="button"
              variant="basic"
              onClick={() => {
                actions.secondary.onClick?.();
                props.onClose?.();
              }}
            >
              {actions.secondary.label}
            </Button>
            <Button
              fullWidth
              type="submit"
              variant="basic"
              disabled={isLoading}
              loading={isLoading}
              onClick={actions.primary.onClick}
            >
              {actions.primary.label}
            </Button>
          </DialogActions>
        </DialogContainer>
      </EventPage>
    </Drawer>
  );
}

EventDrawer.displayName = 'EventDrawer';
